import React from "react";
import Button from "../../common/Button/Button";

const HeroSection = () => {
  return (
    <div className="hero-container">
      <h1 data-aos="fade-down" data-aos-delay="100">
        ACTION NOT WORD
      </h1>
      <p data-aos="fade-up" data-aos-delay="300">
        Investing in The Future of Afghan Youth Through Education
      </p>
      <div className="hero-btns">
        <div className="hero-btn-group">
          <Button
            className="btns"
            buttonStyle="btn--primary"
            buttonSize="btn--large"
            src="about"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            LEARN MORE
          </Button>
          <Button
            className="btns"
            buttonStyle="btn--primary"
            buttonSize="btn--large"
            src="donate"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            DONATE NOW
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
